import ProfileModel from "../../../Profile/Models/ProfileModel";

export enum StandingGamePredictionStatusEnum {
  /**
   * ACTIVE Predictions are made.
   */
  ACTIVE = "ACTIVE",
  /**
   * Settled WON all Predictions are correct.
   */
  WON = "WON",
  /**
   * Settled LOST all Prediction are incorrect.
   */
  LOST = "LOST",
  /**
   * Settled PARTIAL_WON (obtained some points) not all Predictions are correct.
   */
  PARTIALLY_WON = "PARTIALLY_WON",
  /**
   * CANCELED Predictions because game was canceled.
   */
  CANCELED = "CANCELED",
}

export default class StandingGamePredictionModel {
  public id: string = "";
  public profileId: string = "";
  public profileModel: ProfileModel | null = null;
  public total: number = 0;
  public gameId: string = "";
  public totalPoints: number | null = null;
  public gamePoints: number | null = null;
  public bonusPoints: number | null = null;
  public position: number | null = null;
  public status: StandingGamePredictionStatusEnum =
    StandingGamePredictionStatusEnum.ACTIVE;
  public standing: string[] = [];
  public createdAt: string = "";
  public updatedAt: string = "";
}
